// Straight rip off from https://usehooks.com/useEventListener/
// Left this as js cuz i didn't want to figure out the types.
import { noop } from "@services/helpers";
import { useEffect, useRef } from "react";

interface GenericEventHandler {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (event: any): void;
}

export function useEventListener(
  eventName: string,
  handler: GenericEventHandler,
  element = window,
) {
  // Create a ref that stores handler
  const savedHandler = useRef<GenericEventHandler>(null);

  // Update ref.current value if handler changes.
  // This allows our effect below to always get latest handler ...
  // ... without us needing to pass it in effect deps array ...
  // ... and potentially cause effect to re-run every render.
  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(
    () => {
      // Make sure element supports addEventListener
      // On
      const isSupported = element && element.addEventListener;
      if (!isSupported) {
        return noop;
      }
      // Create event listener that calls handler function stored in ref
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const eventListener = (event: any) => {
        if (!savedHandler?.current) {
          return;
        }
        return savedHandler.current(event);
      };

      // Add event listener
      element.addEventListener(eventName, eventListener);

      // Remove event listener on cleanup
      return () => {
        element.removeEventListener(eventName, eventListener);
      };
    },
    [eventName, element], // Re-run if eventName or element changes
  );
}

export const EVENT_KEYS = {
  ArrowLeft: "ArrowLeft",
  ArrowRight: "ArrowRight",
};
